var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _path12, _path13, _path14, _path15, _path16, _path17, _circle3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _rect, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _rect2, _rect3, _path90, _path91;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 292,
    viewBox: "0 0 344 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.753 274.426C171.849 271.848 176 257.578 176 257.578L153.685 252.918C153.685 252.918 155.573 262.303 154.137 270.687C153.337 275.362 152.661 284.342 153.617 287.473C155.931 293.199 189.517 289.099 180.753 274.426Z",
    fill: "#FDCBB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.685 252.917C153.685 252.917 155.574 262.303 154.138 270.687C153.337 275.361 152.661 284.342 153.618 287.473C153.8 287.924 154.177 288.314 154.711 288.643C153.765 284.787 153.512 275.562 154.829 273.252C156.145 270.942 155.177 266.99 156.317 267.533C159.089 268.854 168.428 267.125 175.287 267.546C175.412 264.174 176.001 257.578 176.001 257.578L153.685 252.917Z",
    fill: "#FFDD79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.412 283.858C193.477 282.865 189.059 276.731 180.444 274.315C176.738 277.111 177.023 282.326 175.812 284.706C174.602 287.087 174.048 288.715 163.752 288.637C153.456 288.558 154.438 287.697 153.572 287.473C152.707 287.249 152.574 290.506 153.224 290.511C153.518 290.514 163.03 291.006 173.243 289.897C186.734 290.989 192.56 290.933 194.998 290.892C199.442 290.817 202.306 284.865 198.412 283.858Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.845 270.621C129.105 268.111 138.247 250.397 138.247 250.397L116.667 243.047C116.667 243.047 117.396 252.593 114.947 260.739C113.582 265.281 111.814 274.111 112.381 277.335C111.832 279.047 125.759 282.751 131.893 281.636C135.405 280.566 136.759 276.206 133.845 270.621Z",
    fill: "#FDCBB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.666 243.047C116.666 243.047 117.395 252.593 114.946 260.739C113.581 265.281 111.527 274.368 112.094 277.593C112.22 278.063 112.832 278.239 113.323 278.631C112.854 274.688 113.357 267.037 114.946 264.905C115.777 263.79 116.327 260.741 117.392 261.419C119.982 263.068 125.694 264.764 132.45 266.02C132.986 262.689 138.246 250.398 138.246 250.398L116.666 243.047Z",
    fill: "#FFDD79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 283.792C143.326 281.337 141.932 273.827 133.707 270.481C132.343 274.435 133.42 278.019 132.313 280.284C131.206 282.55 125.649 280.165 118.767 279.265C111.885 278.365 112.649 277.589 112.098 277.298C111.547 277.006 111.052 280.228 111.486 280.284C111.683 280.31 121.02 281.914 125.063 281.914C130.639 281.914 134.264 286.515 144.815 290.499C147.619 291.558 150.458 285.103 147.976 283.792Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0246 130.096H71.7117L40.8194 290.623H38.7598L64.0246 130.096Z",
    fill: "#312E63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.161 129.941H243.474L274.366 290.468H276.426L251.161 129.941Z",
    fill: "#312E63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.472 129.941H248.869L264.516 239.289L243.472 129.941Z",
    fill: "#232056"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7113 130.096H67.8677L46.6191 260.483L71.7113 130.096Z",
    fill: "#232056"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4609 129.106C33.4609 127.874 34.4597 126.875 35.6917 126.875H279.682C280.914 126.875 281.913 127.874 281.913 129.106V131.058C281.913 132.29 280.914 133.288 279.682 133.288H35.6917C34.4597 133.288 33.4609 132.29 33.4609 131.058V129.106Z",
    fill: "#312E63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.456,
    cy: 21.89,
    r: 20.1556,
    fill: "#CCCBEC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.456,
    cy: 21.8894,
    r: 21.75,
    stroke: "#02005B",
    strokeWidth: 0.278846
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.457 21.6726V11.7031",
    stroke: "#02005B",
    strokeWidth: 0.836538,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.133 3.4668V6.28425",
    stroke: "#02005B",
    strokeWidth: 0.557692
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.035 21.5645L139.853 21.5645",
    stroke: "#02005B",
    strokeWidth: 0.557692
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.133 36.8438V39.6612",
    stroke: "#02005B",
    strokeWidth: 0.557692
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.41 21.5645L173.228 21.5645",
    stroke: "#02005B",
    strokeWidth: 0.557692
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.242 21.6719H155.672",
    stroke: "#02005B",
    strokeWidth: 0.836538,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.456,
    cy: 21.8899,
    r: 2.384,
    fill: "#02005B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 290.557H343.817",
    stroke: "#232056",
    strokeWidth: 0.278846
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.274 57.5828C97.6773 64.5642 98.5631 69.348 99.687 73.4769C85.6053 78.0778 79.1845 73.3288 74.0332 64.4144L87.6106 51.3086C92.3875 52.247 94.5305 51.5021 101.274 57.5828Z",
    fill: "#FECBB5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6113 51.3086C92.3882 52.247 94.5312 51.5021 101.275 57.5828C99.368 61.284 98.721 64.3676 98.7015 67.0634C91.1086 63.9403 88.1443 55.2589 87.6113 51.3086Z",
    fill: "#E98E64"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.01 257.097C113.212 230.885 124.086 202.443 131.336 175.395C145.638 170.627 162.516 169.869 161.452 175.395C157.826 194.217 149.461 244.967 145 266.16C138.447 267.832 112.096 257.097 104.01 257.097Z",
    fill: "#02005B",
    stroke: "#1371FF",
    strokeWidth: 0.278846
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.336 175.395C145.638 170.627 162.516 169.869 161.451 175.395C158.506 190.686 152.432 227.052 147.865 251.52C148.955 232.28 151.413 191.708 151.413 187.804C148.848 190.927 144.488 193.474 142.769 193.799L131.336 175.395Z",
    fill: "#09125A",
    stroke: "#1371FF",
    strokeWidth: 0.278846
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.744 262.534C135.519 263.51 117.116 253.89 109.447 253.89C110.786 250.99 127.386 199.509 135.519 174.131",
    stroke: "#1371FF",
    strokeWidth: 0.557692
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.578 266.267C146.408 266.867 156.789 178.948 153.644 182.783C140.957 198.259 124.644 193.722 112.933 193.722C65.948 193.722 52.881 181.765 56.606 154.759C160.895 142.768 170.801 147.252 175.116 151.413C182.924 158.942 182.923 170.932 192.405 266.267C186.688 268.946 161.034 264.764 150.578 266.267Z",
    fill: "#02005B",
    stroke: "#1371FF",
    strokeWidth: 0.278846
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.645 182.783C152.99 183.581 152.328 184.324 151.658 185.014C155.063 180.924 162.122 170.709 163.126 162.566C162.234 170.374 156.751 184.316 154.122 190.312C154.365 185.018 154.285 182.003 153.645 182.783Z",
    fill: "#031677",
    stroke: "#1371FF",
    strokeWidth: 0.278846
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6055 154.76C56.6055 195.053 82.1198 184.039 111.12 190.452C140.12 196.866 153.644 176.231 155.735 179.577C159.639 190.452 153.644 257.933 153.644 262.116C159.221 260.582 183.759 265.183 192.061 262.813",
    stroke: "#1371FF",
    strokeWidth: 0.557692
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M158.267 79.8459C158.345 79.6211 158.556 79.4703 158.794 79.4703H222.741C223.124 79.4703 223.393 79.8478 223.268 80.21L207.861 124.825C207.783 125.05 207.571 125.201 207.334 125.201H143.387C143.004 125.201 142.735 124.823 142.86 124.461L158.267 79.8459Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.557692
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M222.742 79.1914H159.013C158.656 79.1914 158.338 79.4181 158.222 79.7557L157.828 80.9H220.111C220.685 80.9 221.088 81.4655 220.902 82.0086L206.338 124.371C206.151 124.914 206.554 125.48 207.129 125.48H207.386C207.743 125.48 208.061 125.253 208.177 124.916L223.533 80.3002C223.72 79.7571 223.316 79.1914 222.742 79.1914Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.108 122.971H208.577L207.494 126.875H141.654L143.108 122.971Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.944 124.365H204.953L203.87 126.596H143.049L143.944 124.365Z",
    fill: "#9B9B9B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.729 102.561H175.016",
    stroke: "#CCCBEC",
    strokeWidth: 0.557692,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.801 105.039H173.004",
    stroke: "#CCCBEC",
    strokeWidth: 0.557692,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.871 107.826H170.835",
    stroke: "#CCCBEC",
    strokeWidth: 0.557692,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M151.941 110.303H168.976",
    stroke: "#CCCBEC",
    strokeWidth: 0.557692,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.27 85.895C161.349 85.6733 161.559 85.5254 161.795 85.5254H176.526C176.918 85.5254 177.188 85.9189 177.047 86.2843L173.284 96.0094C173.201 96.2242 172.994 96.3659 172.764 96.3659H158.31C157.924 96.3659 157.655 95.9833 157.785 95.6201L161.27 85.895Z",
    fill: "#D7D7D7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M186.955 85.9221C187.048 85.6831 187.277 85.5254 187.533 85.5254H213.998C214.487 85.5254 214.783 86.0647 214.521 86.4771C214.407 86.6559 214.21 86.7643 213.998 86.7643H187.533C187.099 86.7643 186.799 86.3279 186.955 85.9221Z",
    fill: "#D7D7D7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M185.098 89.0197C185.19 88.7807 185.42 88.623 185.676 88.623H212.141C212.629 88.623 212.926 89.1623 212.664 89.5747C212.55 89.7536 212.353 89.862 212.141 89.862H185.676C185.241 89.862 184.942 89.4255 185.098 89.0197Z",
    fill: "#D7D7D7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M183.241 92.1174C183.333 91.8784 183.562 91.7207 183.819 91.7207H210.283C210.772 91.7207 211.068 92.26 210.806 92.6724C210.693 92.8513 210.495 92.9596 210.283 92.9596H183.819C183.384 92.9596 183.084 92.5232 183.241 92.1174Z",
    fill: "#D7D7D7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M181.381 95.2131C181.473 94.9741 181.703 94.8164 181.959 94.8164H208.424C208.913 94.8164 209.209 95.3557 208.947 95.7681C208.833 95.947 208.636 96.0553 208.424 96.0553H181.959C181.524 96.0553 181.225 95.6189 181.381 95.2131Z",
    fill: "#D7D7D7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M187.217 107.256C187.3 107.039 187.507 106.896 187.739 106.896H202.238C202.629 106.896 202.898 107.288 202.759 107.653L199.054 117.378C198.972 117.594 198.765 117.737 198.533 117.737H184.034C183.643 117.737 183.374 117.346 183.513 116.981L187.217 107.256Z",
    fill: "#D7D7D7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M184.767 104.519C184.828 104.357 184.984 104.249 185.158 104.249H207.505C207.798 104.249 208 104.541 207.897 104.815L202.123 120.115C202.062 120.278 201.906 120.386 201.732 120.386H179.385C179.092 120.386 178.89 120.093 178.993 119.82L184.767 104.519Z",
    fill: "#D7D7D7",
    stroke: "#CCCBEC",
    strokeWidth: 0.278846
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M114.465 79.7494C111.998 76.6092 102.072 73.0602 99.2686 72.4994C87.775 76.4247 78.3556 69.4321 74.3119 64.2734C71.8023 65.5282 57.3626 76.9609 55.2107 95.0859C53.2467 111.628 52.366 131.169 55.2107 161.73L124.364 147.37C121.187 120.079 116.932 82.8896 114.465 79.7494Z",
    fill: "#CCCBEC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2692 72.4994C87.7756 76.4247 78.3562 69.4321 74.3125 64.2734",
    stroke: "white",
    strokeWidth: 0.557692
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8317 88.3933C100.412 75.5664 109.077 76.7752 112.587 78.983C114.846 81.8582 120.179 113.92 123.502 140.259C121.28 140.538 114.801 140.928 106.659 140.259C96.4807 139.422 93.8317 116.417 93.8317 112.653C93.8317 108.888 91.0419 93.831 93.8317 88.3933Z",
    fill: "#7372B8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M160.746 116.436C156.712 117.906 155.219 117.906 151.694 117.906L154.785 126.967C155.459 126.424 157.422 125.47 159.882 125.999C168.563 127.866 168.842 125.517 171.471 125.506C173.583 125.497 174.626 123.631 176.884 123.42C178.691 123.251 180.219 124.747 180.758 125.517C181.111 126.021 182.087 127.114 183.851 125.614C181.199 120.453 178.941 120.664 177.535 120.62C174.839 116.868 173.916 119.377 171.992 117.906C167.873 114.673 165.512 114.699 160.746 116.436Z",
    fill: "#FBCBB8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M176.884 123.419C178.69 123.25 180.219 124.746 180.758 125.515C179.847 123.738 176.884 122.273 174.698 123.668C171.212 125.898 171.992 124.225 170.933 124.783C164.331 127.572 159.881 124.922 159.361 124.783C158.945 124.672 157.143 120.002 156.294 117.682C154.876 117.905 153.574 117.905 151.693 117.905L154.785 126.965C155.459 126.423 157.422 125.469 159.881 125.998C168.563 127.865 168.842 125.515 171.471 125.505C173.582 125.496 174.626 123.63 176.884 123.419Z",
    fill: "#E98E64"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6573 106.917C90.3947 86.0874 101.361 77.2402 107.277 77.2402C127.712 77.2402 118.673 117.624 123.833 116.504C128.993 115.384 141.515 116.504 153.333 115.362L159.222 126.841C144.172 134.12 118.785 142.262 108.69 138.902C96.0704 134.703 98.1066 123.773 94.6573 106.917Z",
    fill: "#CCCBEC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M159.221 126.84L153.332 115.361",
    stroke: "white",
    strokeWidth: 0.557692
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.635 62.947C84.6027 61.1478 82.87 42.8031 84.4034 34.1591C88.0876 23.7318 112.076 33.4868 112.28 35.3269L112.281 35.3351C112.494 37.2475 115.535 64.5803 101.635 62.947Z",
    fill: "#FECBB5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4034 34.1591C88.0876 23.7318 112.076 33.4868 112.28 35.3269L112.281 35.3351C112.354 35.9898 112.759 39.6254 112.701 44.0579C103.591 42.6637 101.5 38.2022 100.524 41.6877C98.5718 48.6589 93.8314 49.356 94.2497 47.5435C95.3184 42.6637 94.3891 39.7358 91.1824 42.6637C87.9757 45.5916 93.9708 52.7022 93.8314 54.0964C93.7199 55.2118 91.3134 56.8848 90.1241 57.582C83.8577 51.0282 83.3293 40.2139 84.4034 34.1591Z",
    fill: "#E98E64"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M120.035 36.5049C121.756 25.079 112.952 23.0345 107.925 23.5389C106.201 19.9072 100.284 16.191 96.6136 16.7687C87.9372 18.1341 85.556 24.8175 84.8062 27.7586C73.7353 34.3295 79.2181 41.099 81.7853 43.9651C82.8569 45.1615 78.1962 54.4244 79.7866 57.923C80.8728 60.3158 91.7552 57.923 93.1909 53.695C93.7363 52.0888 91.4195 51.1955 89.8137 46.6305C88.2078 42.0654 92.5634 39.8641 94.5812 41.1617C96.5989 42.4593 93.4412 48.7001 95.426 48.0019C100.774 45.4515 99.4052 38.0186 102.105 39.5894C111.359 44.9743 118.9 44.0409 120.035 36.5049Z",
    fill: "#05185A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M111.679 42.9782C116.177 43.3053 119.334 41.1704 120.036 36.5059C120.719 31.9726 119.745 28.916 118.007 26.9096C122.415 36.5059 114.886 40.0153 111.679 42.9782Z",
    fill: "#312E63"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.92307,
    height: 81.423,
    transform: "matrix(-1 0 0 1 102.014 194.334)",
    fill: "#312E63"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M102.014 275.757H93.0906L102.014 194.334V275.757Z",
    fill: "#232056"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.898 275.758H93.1408C90.7081 278.221 84.3831 280.191 77.085 281.177C69.3004 282.228 62.9754 282.162 62.9754 290.537H133.523C133.523 282.162 129.631 282.162 118.441 281.177C109.488 280.389 103.682 277.236 101.898 275.758Z",
    fill: "#232056"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138.127 194.332V187.527C131.018 176.34 132.133 161.003 120.143 147.897C109.224 135.963 125.303 139.54 91.2926 139.54C89.6777 125.12 87.2383 94.6409 74.6459 89.8748C54.3347 82.1873 34.3699 91.7205 37.3904 116.562C47.08 196.276 52.7013 194.332 66.8005 194.332H138.127Z",
    fill: "#02005B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8013 194.332H138.128V193.061H56.8848C59.7278 194.477 62.9479 194.332 66.8013 194.332Z",
    fill: "#3C3A82"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M109.286 194.461C100.613 194.461 100.028 196.194 89.748 129.494C92.3779 130.797 91.9867 133.793 102.844 135.356C123.149 138.279 126.405 148.489 135.077 175.677L135.147 175.899C136.856 181.255 138.167 185.713 145.517 189.973L142.629 194.461H109.286Z",
    fill: "#3C3A82"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M109.287 194.46H142.63L145.518 189.973H101.229C103.363 194.775 105.591 194.46 109.287 194.46Z",
    fill: "#7372B8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.447 194.496C116.814 194.496 89.726 194.46 142.629 194.46L143.466 193.102H103.033C104.695 194.847 106.764 194.496 109.447 194.496Z",
    fill: "#3C3A82"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M242.307 99.9025C241.409 104.001 242.681 112.269 243.429 115.891H245.3C246.609 110.769 244.926 104.094 244.926 101.144C244.926 98.7848 243.678 94.9869 243.055 93.3828C243.18 93.8485 243.205 95.8044 242.307 99.9025Z",
    fill: "#3C3A82"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M243.617 115.737C241.684 113.098 238.079 106.299 239.127 100.214C239.968 95.3271 240.142 93.2501 240.113 92.568C240.095 92.473 240.078 92.3825 240.062 92.2969C240.087 92.3173 240.106 92.4007 240.113 92.568C240.5 94.6556 241.185 98.9247 241.185 101.3C241.185 104.405 244.552 109.683 245.488 115.737H243.617Z",
    fill: "#7372B8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M238.192 107.509C240.886 109.869 242.557 113.977 243.056 115.737H244.74C245.114 113.408 242.682 108.13 240.063 106.268C237.967 104.777 235.697 100.886 234.824 99.127C234.824 100.938 235.498 105.15 238.192 107.509Z",
    fill: "#3C3A82"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M238.004 110.77C239.8 112.136 240.997 114.651 241.371 115.737H243.055C242.868 114.03 240.81 109.994 238.939 109.062C237.442 108.317 235.821 106.165 235.197 105.182C235.384 106.475 236.208 109.404 238.004 110.77Z",
    fill: "#7372B8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M243.619 115.583C242.933 113.254 242.084 107.852 244.18 104.872C246.78 101.174 248.457 95.3354 248.299 93.7307C248.298 93.7189 248.296 93.7071 248.295 93.6953C248.297 93.7069 248.298 93.7187 248.299 93.7307C248.671 97.1393 248.85 101.318 246.986 106.114C245.489 109.963 245.115 114.031 245.115 115.583H243.619Z",
    fill: "#7372B8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M246.611 107.975C244.516 110.21 244.366 113.666 244.553 115.115H245.301C245.675 113.563 248.107 110.148 249.791 107.664C251.475 105.18 251.288 100.368 251.288 97.2637C251.288 99.7474 249.23 105.18 246.611 107.975Z",
    fill: "#3C3A82"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M250.913 109.216C248.967 110.706 247.109 113.873 246.423 115.27H244.739C244.552 114.805 247.545 109.527 249.416 107.974C251.287 106.422 253.158 102.386 253.906 100.213C254.28 101.92 253.75 107.043 250.913 109.216Z",
    fill: "#7372B8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M252.59 113.846H234.51L238.039 126.873H249.428L252.59 113.846Z",
    fill: "#9B9B9B",
    stroke: "#D7D7D7",
    strokeWidth: 0.278846
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M249.106 126.661H238.324L237.996 124.784L237.667 122.627L237.389 120.803L237.036 118.48L236.682 116.158L236.328 113.836H250.928L250.605 116.158L250.282 118.48L249.959 120.803L249.706 122.627L249.406 124.784L249.106 126.661Z",
    fill: "#9B9B9B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M236.682 116.158L236.328 113.836H250.928L250.605 116.158M236.682 116.158H250.605M236.682 116.158L237.036 118.48M250.605 116.158L250.282 118.48M237.036 118.48H250.282M237.036 118.48L237.389 120.803M250.282 118.48L249.959 120.803M237.389 120.803H249.959M237.389 120.803L237.667 122.627M249.959 120.803L249.706 122.627M237.667 122.627H249.706M237.667 122.627L237.996 124.784M249.706 122.627L249.406 124.784M237.996 124.784L238.324 126.661H249.106L249.406 124.784M237.996 124.784H249.406",
    stroke: "#D7D7D7",
    strokeWidth: 0.278846
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M284.463 193.863C279.361 195.04 268.059 193.628 263.664 178.559C272.69 179.343 286.425 179.736 284.463 193.863Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M293.488 240.562C292.703 222.511 294.744 193.079 273.082 185.23",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M293.014 186.494C290.977 178.976 285.224 170.492 277.791 194.65C284.855 195.827 317.263 192.073 293.014 186.494Z",
    fill: "#FFA24C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M293.096 186.801C293.069 186.699 293.042 186.596 293.014 186.494M293.014 186.494C290.977 178.976 285.224 170.492 277.791 194.65C284.855 195.827 317.263 192.073 293.014 186.494Z",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M281.856 177.649C276.919 180.788 264.437 181.654 254 160.006C264.62 159.7 287.623 160.88 281.856 177.649Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M295.45 171.889C291.787 175.551 282.892 174.714 276.613 142.064C291.133 146.774 311.147 158.546 295.45 171.889Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M304.868 180.128C298.589 175.943 291.996 164.824 315.856 153.836C317.427 163.647 319.778 186.8 304.868 180.128Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M305.651 167.179C300.811 158.807 300.628 140.651 338.615 135C332.337 142.064 308.789 172.28 305.651 167.179Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M315.857 177.381C311.148 172.803 309.657 162.548 341.365 158.152C336.263 165.608 323.706 183.66 315.857 177.381Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M310.754 200.144C312.716 193.342 321.035 182.17 338.616 193.472C332.337 194.65 327.628 193.865 310.754 200.144Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.842 239.778C296.235 222.25 296.235 187.115 293.095 186.801C290.27 188.057 287.732 189.679 286.816 190.333",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M298.984 239.385C297.283 218.063 294.666 161.685 318.999 149.52",
    stroke: "#FFA24C",
    strokeWidth: 0.288628
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M324.49 167.572C308.479 173.223 306.831 218.064 308.008 239.779H309.185C308.123 213.878 309.577 174.636 324.49 167.572Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M316.644 194.256C305.26 199.75 303.17 227.874 303.301 239.777H304.085C304.87 204.851 310.754 198.573 316.644 194.256Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M264.842 164.039C289.957 173.457 289.172 206.421 289.172 239.777H291.527C290.742 211.523 292.704 173.457 264.842 164.039Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M298.196 238.994C298.196 214.114 299.742 164.286 287.14 153.683C286.42 153.104 285.658 152.63 284.854 152.268C285.663 152.605 286.424 153.081 287.14 153.683C300.474 164.388 299.806 210.698 300.551 238.994H298.196Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310 153C302.922 162.989 305.505 218.168 305.28 241H306.629C306.741 221.339 304.27 161.086 310 153Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M318.715 233.434H277.391L286.111 290.682H310.754L318.715 233.434Z",
    fill: "#9B9B9B",
    stroke: "#F0F0F0",
    strokeWidth: 0.278846
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M277.391 233.434H318.715L318.135 237.604L317.555 241.774L316.87 246.703L316.237 251.252L315.604 255.802L314.919 260.731L314.181 266.038L313.443 271.346L312.705 276.654L312.125 280.824L311.439 285.753L310.754 290.682H286.111L285.36 285.753L284.609 280.824L283.974 276.654L283.165 271.346L282.357 266.038L281.548 260.731L280.798 255.802L280.105 251.252L279.412 246.703L278.661 241.774L278.026 237.604L277.391 233.434Z",
    fill: "#9B9B9B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M278.026 237.604L277.391 233.434H318.715L318.135 237.604M278.026 237.604H318.135M278.026 237.604L278.661 241.774M318.135 237.604L317.555 241.774M278.661 241.774H317.555M278.661 241.774L279.412 246.703M317.555 241.774L316.87 246.703M279.412 246.703H316.87M279.412 246.703L280.105 251.252M316.87 246.703L316.237 251.252M280.105 251.252H316.237M280.105 251.252L280.798 255.802M316.237 251.252L315.604 255.802M280.798 255.802H315.604M280.798 255.802L281.548 260.731M315.604 255.802L314.919 260.731M281.548 260.731H314.919M281.548 260.731L282.357 266.038M314.919 260.731L314.181 266.038M282.357 266.038H314.181M282.357 266.038L283.165 271.346M314.181 266.038L313.443 271.346M283.165 271.346H313.443M283.165 271.346L283.974 276.654M313.443 271.346L312.705 276.654M283.974 276.654H312.705M283.974 276.654L284.609 280.824M312.705 276.654L312.125 280.824M284.609 280.824H312.125M284.609 280.824L285.36 285.753M312.125 280.824L311.439 285.753M285.36 285.753L286.111 290.682H310.754L311.439 285.753M285.36 285.753H311.439",
    stroke: "#F0F0F0",
    strokeWidth: 0.278846
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 258.727,
    y: 23.614,
    width: 68.0766,
    height: 52.2381,
    fill: "#FFF7E8",
    stroke: "#CCCBEC",
    strokeWidth: 0.278846
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256.12,
    y: 21.6101,
    width: 73.2922,
    height: 56.2453,
    stroke: "#3C3A82",
    strokeWidth: 0.278846
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M326.943 23.4746H318.906L258.588 75.9916L326.943 23.4746Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M258.588 46.8943L287.147 23.4746H303.293L258.588 63.572V46.8943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration1);
export default __webpack_public_path__ + "static/media/Illustration_1.0241bd383b54c9520e6e375ba343e41b.svg";
export { ForwardRef as ReactComponent };